import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
} from "@mui/material";

const PlanComparisonTable = () => {
  return (
    <div>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{
          marginBottom: 2,
          color: "#2E7D32", // Dark Green
          paddingY: 4,
          fontWeight: "bold",
          letterSpacing: "1px",
          textTransform: "uppercase",
          fontSize: { xs: "21px", sm: "32px" }, // Smaller on mobile (18px), normal on other devices
        }}
      >
        🌿 Plan Comparison 🌾
      </Typography>
      <TableContainer
        component={Paper}
        sx={{
          padding: { xs: 1, sm: 2 },
          paddingX: { xs: 0, sm: 3 },
          marginTop: 3,
          border: "3px solid #4CAF50", // Green border
          borderRadius: "16px",
          width: { xs: "100%", sm: "85%", md: "80%" },
          maxWidth: "100%",
          margin: "auto",
          boxShadow: "0px 6px 12px rgba(0, 128, 0, 0.2)",
          overflow: "hidden",
        }}
      >
        <Table
          size="medium"
          sx={{ borderCollapse: "separate", borderSpacing: 0 }}
        >
          <TableHead>
            <TableRow>
              {["Feature", "🌱 Plantation Crop Plan", "🌾 Field Crop Plan"].map(
                (header, index) => (
                  <TableCell
                    key={index}
                    sx={{
                      fontWeight: "bold",
                      color: "white",
                      textAlign: "center",
                      padding: "14px",
                      backgroundColor: "#388E3C", // Darker Green Header
                      borderRight: index < 2 ? "2px solid #FFFFFF" : "none", // White column separators
                      borderTopLeftRadius: index === 0 ? "12px" : "0px",
                      borderTopRightRadius: index === 2 ? "12px" : "0px",
                    }}
                  >
                    {header}
                  </TableCell>
                )
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {[
              ["Crop Types", "Tea, Coffee, etc.", "Wheat, Rice, etc."],
              ["AI-Powered Crop Monitoring", "✅ Yes", "✅ Yes"],
              ["Soil Health Analysis", "✅ Advanced", "✅ Basic"],
              ["Weather & Pest Alerts", "✅ Yes", "✅ Yes"],
              [
                "Irrigation Management",
                "✅ Drip & Sprinkler Optimization",
                "✅ Flood & Sprinkler Optimization",
              ],
              ["Yield Prediction", "✅ Yes", "✅ Yes"],
              [
                "Fertilizer & Nutrient Advice",
                "✅ Customized for Tree Crops",
                "✅ Customized for Seasonal Crops",
              ],
              [
                "Market Price Updates",
                "✅ Plantation Crop Prices",
                "✅ Field Crop Prices",
              ],
              ["Farm Management Dashboard", "✅ Yes", "✅ Yes"],
              [
                "IoT Sensor Integration",
                "✅ Advanced (Moisture, Climate, Growth Tracking)",
                "✅ Basic (Soil & Weather Monitoring)",
              ],
              [
                "Best For",
                "Large-Scale Plantation Owners",
                "Small & Large Field Farmers",
              ],
            ].map(([feature, plantation, field], index) => (
              <TableRow
                key={index}
                sx={{
                  backgroundColor: index % 2 === 0 ? "#F1F8E9" : "white", // Zebra striping
                  "&:hover": {
                    backgroundColor: "#C8E6C9", // Light green hover effect
                    transition: "0.3s ease-in-out",
                  },
                }}
              >
                {[feature, plantation, field].map((text, cellIndex) => (
                  <TableCell
                    key={cellIndex}
                    align={cellIndex === 0 ? "left" : "center"}
                    sx={{
                      fontWeight: cellIndex === 0 ? "bold" : "normal",
                      color: cellIndex === 0 ? "#2E7D32" : "inherit",
                      borderBottom: "2px solid #A5D6A7",
                      borderRight: cellIndex < 2 ? "2px solid #A5D6A7" : "none", // Vertical separator
                      padding: "14px",
                    }}
                  >
                    {text}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default PlanComparisonTable;
